import { useDroppable } from "@dnd-kit/core";

import classes from "./DroppableArea.module.css";
import clsx from "clsx";

const DroppableArea = () => {
  const { isOver, setNodeRef } = useDroppable({ id: "dock" });

  return (
    <div className={`${classes.DropZone}`} >
      <div ref={setNodeRef} className={`${classes.DroppableArea}`} >
        <div
        className={clsx(classes.DroppableGraphic, isOver && classes.hovered)}
        // style={{ color: isOver ? "#F6BA66" : "#016CB8", borderColor: isOver ? "#F6BA66" : "#016CB8" }}
        >
          +
        </div>
      </div>
    </div>
  );
};

export default DroppableArea;